import { useRdContext } from '@neo.tax/rd/context';
import { useRdProjects, useRdPageLockStatus } from '@neo.tax/rd/hooks';
import { useProviderTokensAndSyncedProviders, RedirectState } from '@neo.tax/shared';

export const useAccountingQresRedirect = (): RedirectState => {
  const { fiscalYearId } = useRdContext();
  const { loading: loadingSyncedProviders } = useProviderTokensAndSyncedProviders({ fiscalYearId });
  const { loading: loadingRdProjects } = useRdProjects();
  const { loading: loadingPageLockStatus } = useRdPageLockStatus();

  return {
    isLoading: loadingSyncedProviders || loadingRdProjects || loadingPageLockStatus,
  };
};
